module.exports = __webpack_public_path__ + "img/cc_brand.bad543eb.png";